<template>
  <div class="p-4">
    <b-row>
      <b-col sm="12" lg="4" md="2"></b-col>
      <b-col sm="12" lg="4" md="8">
        <div class="bg-white p-4">
          <div>
            <div class="text-center mb-5 mb-lg-10">
              <h3 class="font-size-h1">{{ $t("login.title") }}</h3>
            </div>
            <b-form class="form" style="width: 100%">
              <b-form-group
                id="example-input-group-1"
                label
                label-for="example-input-1"
              >
                <label>{{ $t("login.username") }}</label>
                <b-form-input
                  @keyup.enter="onSubmit"
                  autocomplete="off"
                  style="padding: 14px"
                  class="form-control form-control-solid h-auto"
                  id="example-input-1"
                  name="example-input-1"
                  v-model.trim="$v.form.username.$model"
                  aria-describedby="input-1-live-feedback"
                  :state="validateState('username')"
                  :placeholder="$t('login.username')"
                ></b-form-input>

                <b-form-invalid-feedback id="input-1-live-feedback"
                  >{{ $t("error.name_error") }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="example-input-group-2"
                label
                label-for="example-input-2"
              >
                <label>{{ $t("login.password") }}</label>
                <b-input-group class="mt-3">
                  <b-form-input
                    style="padding: 14px"
                    @keyup.enter="onSubmit"
                    class="form-control form-control-solid h-auto"
                    type="password"
                    id="example-input-2"
                    name="example-input-2"
                    :placeholder="$t('login.password')"
                    v-model="$v.form.password.$model"
                    :state="validateState('password')"
                    aria-describedby="input-2-live-feedback"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-2-live-feedback"
                    >{{ $t("error.name_error") }}
                  </b-form-invalid-feedback>
                  <b-input-group-append v-if="form.password">
                    <b-button variant="outline-primary" @click="showPswd"
                      ><i class="fa fa-eye"></i
                    ></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>

              <!--begin::Action-->
              <div
                class="
                  form-group
                  d-flex
                  flex-wrap
                  justify-content-between
                  align-items-center
                "
              >
                <b-button
                  block
                  variant="primary"
                  @click.prevent="onSubmit"
                  ref="kt_login_signin_submit"
                  class="btn float-right p-3 mt-3"
                  >{{ $t("login.come_out") }}
                </b-button>
                <a
                  @click.prevent="openOneId"
                  href="#"
                  id="one-id-btn"
                  class="mt-3"
                >
                  {{ $t("login.loginWithOneId") }}
                </a>
              </div>
            </b-form>
            <div class="text-center mb-2 mb-lg-5"></div>
            <div class="text-center mb-5 mb-lg-10"></div>
            <div class="mt-5 mb-2" style="text-align: right">
              <span class="font-weight-bold font-size-4 text-dark-60">
                <b-link href="#" @click="forgetPSWD">{{
                  $t("login.forgetPassword")
                }}</b-link>
              </span>
            </div>
          </div>
        </div>
      </b-col>
      <b-col sm="12" lg="4" md="2"></b-col>
    </b-row>

    <!--          Forget Password           -->
    <b-modal
      hide-footer
      v-model="isForget"
      no-close-on-backdrop
      :title="$t('login.forgetPassword')"
    >
      <b-row class="mb-2"
        ><b-col
          ><p>{{ $t("forgetPasswordText") }}</p></b-col
        ></b-row
      >
      <b-row><b-col>Passport *</b-col></b-row>
      <b-row class="mt-1">
        <b-col cols="4">
          <vue-select
            class="style-ch"
            @search="fetchOptions"
            v-model="forgetForm.passportSerialTitle"
            :options="passportSeriaList"
            label="title"
          />
        </b-col>
        <b-col cols="8">
          <b-form-input
            v-model="forgetForm.passportNumber"
            v-mask="'#######'"
            type="number"
          />
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col align="right">
          <b-button
            @click="sendConfirmPassword"
            align="right"
            variant="success"
          >
            {{ $t("actions.send") }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      hide-footer
      v-model="editPassword"
      no-close-on-backdrop
      :title="$t('login.forgetPassword')"
    >
      <b-form-group
        :label="$t('register.password') + ' *'"
        label-for="horizontal-firstname-input"
        label-cols-sm="3"
      >
        <b-input-group>
          <b-form-input
            v-model="editPasswordForm.newPassword"
            :type="password ? 'password' : 'text'"
            :min="8"
          />
          <b-input-group-append>
            <b-button variant="outline-primary" @click="password = !password">
              <i class="fa fa-eye" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group
        :label="$t('register.confirmCode') + ' *'"
        label-for="horizontal-firstname-input"
        label-cols-sm="3"
      >
        <b-form-input v-model="editPasswordForm.confirmCode" type="text" />
      </b-form-group>
      <div class="text-center">
        <vue-countdown-timer
          @end_callback="endCallBack"
          :start-time="dateNow"
          :end-time="expireDate"
          :interval="1000"
        >
          <template slot="countdown" slot-scope="scope">
            <h1 class="text-danger">
              <strong>{{
                `${scope.props.minutes} : ${scope.props.seconds}`
              }}</strong>
            </h1>
          </template>
        </vue-countdown-timer>
      </div>
      <b-row class="mt-3">
        <b-col align="left">
          <b-button @click="backToForget" align="right" variant="danger">
            {{ $t("actions.back") }}
          </b-button>
        </b-col>
        <b-col align="right">
          <b-button @click="confirmPassword" align="right" variant="success">
            {{ $t("actions.save") }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      :no-close-on-backdrop="true"
      :hide-footer="true"
      :hide-header="true"
      v-model="confirmCode"
    >
      <b-row class="mb-5">
        <b-card>
          <b-card-header>
            <b-col cols="12">
              <span style="font-size: 14px" class="ml-2 text-wrap mb-3">{{
                $t("login.sendConfirmCode")
              }}</span>
            </b-col>
          </b-card-header>
          <b-card-text>
            <b-col cols="12" class="mb-2 mt-5">{{
              $t("login.confirmCode")
            }}</b-col>
            <b-col cols="12" class="mb-5">
              <b-form-input
                autocomplete="off"
                :placeholder="$t('register.confirmCode')"
                class="form-control form-control-solid h-auto py-4 px-5"
                id="example-input-0"
                name="example-input-0"
                v-model="$v.forgetForm.code.$model"
                :state="validateStates('code')"
                aria-describedby="input-1-live-feedback"
              ></b-form-input>
            </b-col>

            <b-col cols="12" class="mb-2">{{
              $t("login.newPasswordEntered")
            }}</b-col>
            <b-col>
              <b-form-group class="mb-2">
                <b-form-input
                  id="example-input-5"
                  class="form-control form-control-solid h-auto py-4 px-5"
                  type="password"
                  v-model="$v.forgetForm.NewPassword.$model"
                  aria-describedby="input-password-live-feedback"
                ></b-form-input>
                <password-meter
                  :password="forgetForm.NewPassword"
                  @score="onScore"
                />
                <div class="text-wrap">{{ messagePSWD }}</div>
                <b-form-invalid-feedback
                  id="input-password-live-feedback"
                  class="f"
                ></b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col v-if="forgetForm.NewPassword" cols="1">
              <b-button
                style="padding: 12px"
                variant="outline-primary"
                @click="showPswdNewPassword"
                ><i class="fa fa-eye"></i>
              </b-button>
            </b-col>
          </b-card-text>
        </b-card>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-button
            class="float-right"
            variant="outline-primary"
            @click.prevent="confirmForget"
          >
            {{ $t("login.forgetConfirm") }}
          </b-button>
          <b-button
            class="float-right mr-3"
            variant="outline-danger"
            @click="cancelConfirmForget"
          >
            {{ $t("actions.cancel") }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import passwordMeter from "vue-simple-password-meter";
import { mapActions, mapState } from "vuex";
import { validationMixin } from "vuelidate";
import {
  email,
  integer,
  maxLength,
  minLength,
  required,
} from "vuelidate/lib/validators";
import { UserService } from "@/services/user.service";
import { bus } from "@/main";
import i18n from "@/core/plugins/vue-i18n";

export default {
  mixins: [validationMixin],
  components: {
    passwordMeter,
  },
  computed: {
    ...mapState("passportSeria", { passportSeriaList: "list" }),
    params() {
      return {
        order: "",
        page: 0,
        limit: 100,
        type: "",
        search: this.search,
      };
    },
    expireDate() {
      return this.date + this.minutes;
    },
  },
  async created() {
    await this.getpassportSeriaList(this.params);
  },
  name: "login",
  data() {
    return {
      messagePSWD: "",
      has_minimum_lenth: false,
      has_number: false,
      has_lowercsae: false,
      has_uppercase: false,
      has_special: false,
      max: 100,
      score: null,
      search: {
        title: null,
      },
      forgetForm: {
        passportNumber: "",
        passportSerialTitle: null,
      },
      dateNow: Date(Date.now()),
      date: Date.now(),
      minutes: 60 * 2 * 1000,
      editPasswordForm: {
        newPassword: "",
        confirmCode: "",
      },
      isInfo1: false,
      isBTN1: false,
      isBTN2: false,
      isInfo2: false,
      isForget: false,
      editPassword: false,
      password: true,
      chooseUsername: false,
      choosePassword: false,
      chooseEmail: false,
      choosePhone: false,
      selectSendCode: "",
      selectByRegister: "",
      confirmCode: false,
      isAgree: false,
      isAgreeCheckbox: false,
      // Remove this dummy login info
      registerForm: false,
      isEspModal: false,
      isLoadingEspLogin: false,
      form: {
        username: "",
        password: "",
      },
    };
  },
  validations: {
    form: {
      username: {
        required,
      },

      password: {
        required,
      },
    },
    forgetForm: {
      email: {
        email,
      },
      phone: {},
      username: {
        minLength: minLength(3),
      },
      passportNumber: {
        integer,
        minLength: minLength(7),
        maxLength: maxLength(7),
      },
      passportSerialId: {},
      code: { required },
      NewPassword: {
        required,
        minLength: minLength(3),
      },
    },
  },
  watch: {
    "forgetForm.NewPassword": async function (newValue) {
      if (this.form.password === "") {
        (this.messagePSWD = this.$t("secury.fullMsg")),
          (this.has_minimum_lenth = false);
        this.has_number = false;
        this.has_lowercsae = false;
        this.has_uppercase = false;
        this.has_special = false;
      }
    },
    selectSendCode: {
      async handler(value) {
        if (this.selectSendCode === "username") {
          this.forgetForm.username = "";
          this.forgetForm.passportNumber = "";
          this.forgetForm.passportSerialId = null;
          this.chooseUsername = true;
          this.choosePassword = false;
          this.isBTN1 = false;
          this.isInfo1 = false;
        } else if (this.selectSendCode === "passport") {
          this.forgetForm.username = "";
          this.forgetForm.passportNumber = "";
          this.forgetForm.passportSerialId = null;
          this.choosePassword = true;
          this.chooseUsername = false;
          this.isBTN1 = false;
          this.isInfo1 = false;
        }
      },
    },
    selectByRegister: {
      async handler(value) {
        if (this.selectByRegister === "email") {
          this.forgetForm.email = "";
          this.forgetForm.phone = "";
          this.chooseEmail = true;
          this.choosePhone = false;
          this.isBTN2 = false;
          this.isInfo2 = false;
        } else if (this.selectByRegister === "phone") {
          this.forgetForm.email = "";
          this.forgetForm.phone = "";
          this.chooseEmail = false;
          this.choosePhone = true;
          this.isBTN2 = false;
          this.isInfo2 = false;
        }
      },
    },
  },
  methods: {
    openOneId() {
      this.WinPrint = window.open(
        `https://sso.egov.uz/sso/oauth/Authorization.do?response_type=one_code&client_id=e-advokat&redirect_uri=${process.env.VUE_APP_ROOT_URL}/oneId&scope=e-advokat&state=eyJtZXRob2QiOiJJRFBXIn0=`,
        "_self",
        "One Id",
        "left=0,top=0,width=1000,height=1000,toolbar=0,scrollbars=0,status=0"
      );
    },
    showPswdNewPassword() {
      var x = document.getElementById("example-input-5");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },
    showPswd() {
      var x = document.getElementById("example-input-2");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },
    onScore({ score, strength }) {
      this.score = score;
      this.has_minimum_lenth = this.forgetForm.NewPassword.length >= 8;
      this.has_number = /\d/.test(this.forgetForm.NewPassword);
      this.has_lowercsae = /[a-z]/.test(this.forgetForm.NewPassword);
      this.has_uppercase = /[A-Z]/.test(this.forgetForm.NewPassword);
      this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(
        this.forgetForm.NewPassword
      );
      this.messagePSWD = " " + this.$t("secury.msg1");

      if (this.has_minimum_lenth === false) {
        this.messagePSWD += " " + this.$t("secury.msg2");
      }
      if (this.has_number === false) {
        this.messagePSWD += " " + this.$t("secury.msg3");
      }
      if (this.has_lowercsae === false) {
        this.messagePSWD += " " + this.$t("secury.msg4");
      }
      if (this.has_uppercase === false) {
        this.messagePSWD += " " + this.$t("secury.msg5");
      }
      if (this.has_special === false) {
        this.messagePSWD += " " + this.$t("secury.msg6");
      }
      this.messagePSWD += " " + this.$t("secury.msg7");

      if (
        this.has_special &&
        this.has_uppercase &&
        this.has_lowercsae &&
        this.has_number &&
        this.has_minimum_lenth
      ) {
        this.messagePSWD = this.$t("secury.successPswdSecury");
      }

      if (score === null || score === undefined || score === "") {
        this.messagePSWD = "";
        this.has_minimum_lenth = false;
        this.has_number = false;
        this.has_lowercsae = false;
        this.has_uppercase = false;
        this.has_special = false;
      }
    },
    ...mapActions("passportSeria", { getpassportSeriaList: "getList" }),
    ...mapActions("auth", ["login", "loginByToken"]),
    // ESP LOGIN MODAL METHODS
    badgeUsername() {
      this.forgetForm.username = "";
      this.forgetForm.passportNumber = "";
      this.forgetForm.passportSerialId = null;
      this.chooseUsername = true;
      this.choosePassword = false;
      this.isBTN1 = false;
      this.isInfo1 = false;
      this.selectSendCode = "username";
    },
    badgePassport() {
      this.forgetForm.username = "";
      this.forgetForm.passportNumber = "";
      this.forgetForm.passportSerialId = null;
      this.choosePassword = true;
      this.chooseUsername = false;
      this.isBTN1 = false;
      this.isInfo1 = false;
      this.selectSendCode = "passport";
    },
    badgePhone() {
      this.forgetForm.email = "";
      this.forgetForm.phone = "";
      this.chooseEmail = false;
      this.choosePhone = true;
      this.isBTN2 = false;
      this.isInfo2 = false;
      this.selectByRegister = "phone";
    },
    badgeEmail() {
      this.forgetForm.email = "";
      this.forgetForm.phone = "";
      this.chooseEmail = true;
      this.choosePhone = false;
      this.isBTN2 = false;
      this.isInfo2 = false;
      this.selectByRegister = "email";
    },
    info1() {
      this.isInfo1 = true;
    },
    info2() {
      this.isInfo2 = true;
    },
    async fetchOptions(search, loading) {
      this.search.title = search;
      await this.getpassportSeriaList(this.params);
    },
    async saveForget() {
      // let bool = this.checkValidity();
      // if (bool) {
      UserService.forGetPassword(this.forgetForm)
        .then((res) => {
          if (res.status === 200) {
            this.isForget = false;
            this.confirmCode = true;
          } else {
            this.$toast.error("Ma'lumotni tog'ri kiriting");
          }
        })
        .catch((error) => {
          this.$toast.error(error.message);
        });
    },
    sendConfirmPassword() {
      let form = {
        passportNumber: this.forgetForm.passportNumber
          ? this.forgetForm.passportNumber
          : null,
        passportSerialTitle: this.forgetForm.passportSerialTitle
          ? this.forgetForm.passportSerialTitle.title
          : null,
      };
      if (form.passportSerialTitle && form.passportNumber) {
        UserService.forgetPassword(form)
          .then((res) => {
            this.isForget = false;
            this.$toast.success(this.$t("send_code"));
            this.dateNow = Date(Date.now());
            this.date = Date.now();
            this.minutes = 60 * 2 * 1000;
            this.editPassword = true;
          })
          .catch((e) => {
            if (
              e.response.data == "Bunday pasport bilan ro'yhatdan o'tilmagan"
            ) {
              if (this.$i18n.locale == "uz") {
                e.response.data = "Бундай паспорт билан рўйхатдан ўтилмаган";
              }
            }
            this.$toast.error(e.response.data, { timeout: 5000 });
          });
      } else {
        this.$toast.error(this.$t("required_error"));
      }
    },
    endCallBack() {
      this.dateNow = Date(Date.now());
      this.date = Date.now();
      this.minutes = 60 * 100 * 1000;
      this.backToForget();
    },
    confirmPassword() {
      let form = {
        newPassword: this.editPasswordForm.newPassword
          ? this.editPasswordForm.newPassword
          : null,
        confirmCode: this.editPasswordForm.confirmCode
          ? this.editPasswordForm.confirmCode
          : null,
        passportSerialTitle: this.forgetForm.passportSerialTitle.title,
        passportNumber: this.forgetForm.passportNumber,
      };
      if (form.newPassword && form.confirmCode) {
        if (form.newPassword.length < 8) {
          this.$toast.error(this.$t("password_error"));
        } else {
          UserService.forGetConfirm(form)
            .then((res) => {
              this.editPassword = false;
              this.$toast.success(this.$t("success"));
              this.editPasswordForm.newPassword = "";
              this.editPasswordForm.confirmCode = "";
              this.forgetForm.passportNumber = "";
              this.forgetForm.passportSerialTitle = null;
            })
            .catch((e) => {
              if (e.response.data == "Tasdiqlash kodi noto'g'ri") {
                if (this.$i18n.locale == "uz") {
                  e.response.data = "Тасдиқлаш коди нотўғри";
                }
              } else if (
                e.response.data == "Bunday pasport bilan nomzod topilmadi"
              ) {
                if (this.$i18n.locale == "uz") {
                  e.response.data = "Бундай паспорт билан номзод топилмади";
                }
              }
              this.$toast.error(e.response.data);
            });
        }
      } else {
        this.$toast.error(this.$t("required_error"));
      }
    },
    backToForget() {
      this.editPasswordForm.newPassword = "";
      this.editPasswordForm.confirmCode = "";
      this.editPassword = false;
      this.isForget = true;
    },
    checkValidity() {
      this.$v.forgetForm.username.$touch();
      this.$v.forgetForm.email.$touch();
      this.$v.forgetForm.phone.$touch();
      this.$v.forgetForm.passportNumber.$touch();
      this.$v.forgetForm.passportSerialId.$touch();
      this.$v.forgetForm.passportSerialTitle.$touch();

      if (
        !this.$v.forgetForm.username.$anyError &&
        !this.$v.forgetForm.email.$anyError &&
        !this.$v.forgetForm.phone.$anyError &&
        !this.$v.forgetForm.passportNumber.$anyError &&
        !this.$v.forgetForm.passportSerialId.$anyError &&
        !this.$v.forgetForm.passportSerialTitle.$anyError
      ) {
        return true;
      } else {
        return false;
      }
    },
    cancelForget() {
      this.isInfo1 = false;
      this.isBTN1 = false;
      this.isBTN2 = false;
      this.isInfo2 = false;
      this.isForget = false;
      this.chooseUsername = false;
      this.choosePassword = false;
      this.chooseEmail = false;
      this.choosePhone = false;
      this.selectSendCode = "";
      this.selectByRegister = "";
    },
    cancelConfirmForget() {
      this.isInfo1 = false;
      this.isBTN1 = false;
      this.isBTN2 = false;
      this.isInfo2 = false;
      this.isForget = false;
      this.chooseUsername = false;
      this.choosePassword = false;
      this.chooseEmail = false;
      this.choosePhone = false;
      this.selectSendCode = "";
      this.selectByRegister = "";
      this.confirmCode = false;
      this.forgetForm.NewPassword = null;
      this.forgetForm.code = null;
    },

    forgetPSWD() {
      this.isForget = true;
      this.isBTN1 = true;
      this.isBTN2 = true;
    },
    confirmForget() {
      // this.isForget = true
      // this.isBTN1 = true
      // this.isBTN2 = true
      let dataForm;
      if (this.selectSendCode === "passport") {
        dataForm = {
          confirmCode: this.forgetForm.code,
          newPassword: this.forgetForm.NewPassword,
          passportSerialId: this.forgetForm.passportSerialId.id,
          passportNumber: this.forgetForm.passportNumber,
        };
      } else if (this.selectSendCode === "username") {
        dataForm = {
          confirmCode: this.forgetForm.code,
          newPassword: this.forgetForm.NewPassword,
          username: this.forgetForm.username,
        };
      }

      UserService.forGetConfirm(dataForm)
        .then((res) => {
          if (res.status === 200) {
            this.$toast.info("successfully changed password");
            this.confirmCode = false;
            this.isInfo1 = false;
            this.isBTN1 = false;
            this.isBTN2 = false;
            this.isInfo2 = false;
            this.isForget = false;
            this.chooseUsername = false;
            this.choosePassword = false;
            this.chooseEmail = false;
            this.choosePhone = false;
            this.selectSendCode = "";
            this.selectByRegister = "";
            this.forgetForm.code = null;
            this.forgetForm.NewPassword = null;
          }
        })
        .catch((error) => {
          this.$toast.info(error.response.data);
        });
    },
    toRegister() {
      this.isAgree = true;
    },
    toLogin() {
      this.isEspModal = false;
    },
    byToken() {
      this.isEspModal = true;
    },
    async loginESP(data) {
      this.isEspModal = false;
      this.isLoadingEspLogin = true;
      let authData = {
        signedData: data,
        username: "",
        password: "",
      };
      this.loginByToken(authData)
        .then((response) => {
          if (!response) {
            this.$showMsgError("Неправильное имя пользователя или пароль.");
          }
        })
        .finally((e) => {
          this.isLoadingEspLogin = false;
        });
    },
    //END
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateStates(name) {
      const { $dirty, $error } = this.$v.forgetForm[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const username = this.$v.form.username.$model;
      const password = this.$v.form.password.$model;

      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(async () => {
        let res = await this.login({
          username: username,
          password: password,
        });
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        // if (!res) {

        //   return;
        // } else {
        //   this.$emit("close");
        // }
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
#one-id-btn {
  border-radius: 4px;
  text-decoration: none;
  text-align: center;
  display: block;
  width: 100%;
  border: 1px solid;
  border-color: rgb(72, 37, 194);
  color: rgb(72, 37, 194);
  padding: 12px;
  transition: all ease 0.5s;
  &:hover {
    background: rgb(72, 37, 194);
    color: #fff;
  }
}
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}

.s {
  width: 350px !important;
}

.style-chooss .vs__search::placeholder,
.style-chooss .vs__dropdown-toggle,
.style-chooss .vs__dropdown-menu {
  background: #fff;
  border: 0px solid #e5eaee;
  padding: 3px;
  border: 1px solid #ced4da;
  color: #394066;
}
</style>


